(function () {
  angular
    .module('kareo.errors.recent-route-history-service', [])
    .factory('recentRouteHistoryService', recentRouteHistoryService)
    .run(standUp);

  var MAX_HISTORY_LENGTH = 3;

  recentRouteHistoryService.$inject = ['$rootScope'];
  function recentRouteHistoryService($rootScope) {
    var routeHistory = [];

    listen();

    return {
      getRecentRouteHistory
    };

    // -----------------------------------------------------------------------

    function getRecentRouteHistory() {
      return routeHistory;
    }

    function listen() {
      $rootScope.$on('$stateChangeStart', stateChanged);
    }

    function stateChanged(event, toState, toParams) {
      if (routeHistory.length === MAX_HISTORY_LENGTH) {
        routeHistory.shift();
      }

      routeHistory.push({
        state: toState.name,
        params: toParams
      });
    }
  }

  /* eslint-disable angular/di-unused */
  standUp.$inject = ['recentRouteHistoryService'];
  function standUp() {}
})();
